var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoPlaceholderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5137 27.6679C43.9908 23.4256 39.381 20.8322 34.1114 20.8322C26.1339 20.8322 19.9137 26.9706 19.9137 35C19.9137 43.0294 26.1339 49.7855 34.1114 49.7855C39.381 49.7855 43.9908 46.698 46.5137 42.4557H53.7445C50.7563 50.3727 43.0256 56 34.1114 56C22.5883 56 13 46.598 13 35C13 23.402 22.5883 14 34.1114 14C43.0256 14 50.7563 19.7508 53.7445 27.6679H46.5137V27.6679ZM57.3259 32.5295L50.0411 37.7177H40.9016C39.8372 40.4639 37.1726 42.4118 34.0517 42.4118C29.9943 42.4118 26.7052 39.1211 26.7052 35.0618C26.7052 31.0025 29.9943 27.7118 34.0517 27.7118C37.2196 27.7118 39.9189 29.7178 40.9503 32.5295H57.3259Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoPlaceholderLogo);
export default __webpack_public_path__ + "static/media/Crypto_placeholder_logo.66d5b01df4a0d23dae55966972b4a2e2.svg";
export { ForwardRef as ReactComponent };